import React, { FunctionComponent, useState } from 'react';

// MUI
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { Add, Remove } from '@mui/icons-material';

// Common
import { GENERAL } from '../../constants';

// Components
import { ModalCookies } from './components/ModalCookies';

// Properties
import * as styles from './Footer.styles';

const Footer: FunctionComponent = () => {
    const [ expanded, setExpanded ] = useState<number | false>(0);
    const [ openModal, setModalStatus ] = useState(false);

    const handleOpenModal = () => setModalStatus(true);
    const handleCloseModal = () => setModalStatus(false);

    const handleChange = (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <AppBar sx={styles.footer} component="footer" position="static">
            <Container>
                <Grid container>
                    <Grid item xs={12} sx={styles.menu}>
                        {
                            GENERAL.FOOTER_LINKS.map((item, index) => {
                                if (!item.active) return null;
                                return (
                                    <Accordion
                                        key={item.label}
                                        expanded={expanded === index + 1}
                                        onChange={handleChange(index + 1)}
                                        disableGutters
                                        elevation={0}
                                        square
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={expanded === index + 1 ?
                                                <Remove/> : <Add/>}
                                            sx={styles.accordionSummary}
                                        >
                                            {item.label}
                                        </AccordionSummary>
                                        <AccordionDetails
                                            sx={styles.accordionDetails}
                                        >
                                            <MenuList sx={styles.menuList}>
                                                {
                                                    item.links.map((link) => {
                                                        return (
                                                            <MenuItem
                                                                key={link.label}
                                                                disableRipple
                                                                sx={styles.menuItem}
                                                            >
                                                                <Link
                                                                    href={link.url}
                                                                    underline="hover"
                                                                    sx={styles.menuLink}
                                                                >
                                                                    {link.label}
                                                                </Link>
                                                            </MenuItem>
                                                        );
                                                    })
                                                }
                                            </MenuList>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <Divider sx={styles.divider}/>
                        <Box sx={styles.copyright}>
                            <Box component="span" sx={styles.copyrightItem}>
                                {GENERAL.FOOTER_COPYRIGHT}
                            </Box>
                            <Box component="span" sx={styles.copyrightItem}>
                                {GENERAL.FOOTER_COOKIES_TEXT}
                                <Link
                                    component="button"
                                    underline="hover"
                                    onClick={() => handleOpenModal()}
                                    sx={styles.link}
                                >
                                    {GENERAL.FOOTER_COOKIES_LINK}
                                </Link>
                                {
                                    openModal && (
                                        <ModalCookies
                                            open={openModal}
                                            onClose={handleCloseModal}
                                        />
                                    )
                                }
                            </Box>
                            <Box component="span" sx={styles.copyrightItem}>
                                <Link
                                    href={GENERAL.RODO_URL}
                                    underline="hover"
                                    sx={styles.link}
                                >
                                    {GENERAL.RODO_LINK}
                                </Link>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </AppBar>
    );
};

export default Footer;
